import React, { FC }              from 'react';
import { formatOption }           from '../../../../util';
import { SelectField }            from '../../../components/forms';
import { SYSTEM_ROLES }           from '../../../../constants/ProductEnums';
import { SYSTEM_ROLE_INFO }       from '../../../../constants/ProductEnums';
import { PreSelectedSelectField } from '../../../../types';
import { LangService }            from '../../../../services';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( SYSTEM_ROLES.CORVALADMIN, LangService.getTermFromDictionary( SYSTEM_ROLE_INFO.CORVALADMIN.LABEL ) ),
		formatOption( SYSTEM_ROLES.ACCOUNTSADMIN, LangService.getTermFromDictionary( SYSTEM_ROLE_INFO.ACCOUNTSADMIN.LABEL ) ),
		formatOption( SYSTEM_ROLES.DECISIONENGINEADMIN, LangService.getTermFromDictionary( SYSTEM_ROLE_INFO.DECISIONENGINEADMIN.LABEL ) ),
		formatOption( SYSTEM_ROLES.MEMBER, LangService.getTermFromDictionary( SYSTEM_ROLE_INFO.MEMBER.LABEL ) ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = {};

export { Dropdown as SystemRoleDropdown }
